import React from 'react';
import './index.css';
import ReactDOM from 'react-dom/client';
import App from './App';

// Register service worker only in production builds to avoid stale cache during dev
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((err) => {
      console.warn('SW registration failed', err);
    });
  });
} else if ('serviceWorker' in navigator) {
  // Ensure dev server always uses fresh bundles
  navigator.serviceWorker.getRegistrations?.().then((regs) => {
    regs.forEach((reg) => reg.unregister().catch(() => undefined));
  }).catch(() => undefined);
}

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);